<template>
  <div class="modal fade" id="bayked_customer_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="myModalLabel">Add / Update Customer: {{customer.name}}</h4>
        </div>
        <form method="post" @submit.prevent="updateBaykedCustomer()">
          <div class="modal-body">
            <div class="form-group">
              <label for="name">Name</label>
              <input v-model="customer.name"
                     type="text"
                     required="required"
                     class="form-control"
                     id="name"
                     placeholder="Enter Customer Name...">
            </div>

            <div class="form-group margin_bottom">
              <label for="name">Phone Number</label>
              <input v-model="customer.contactNumber"
                     required="required"
                     class="form-control"
                     id="contactNumber"
                     type="tel"
                     readonly="readonly"
                     placeholder="0xxxxxxxxxx or +xxxxxxxxxx">
            </div>

            <div class="checkbox">
              <label>
                <input type="checkbox"
                       v-model="customer.contactNumberVerified"/>
                phone number verified?
              </label>
            </div>

            <div class="form-group">
              <label for="name">Email</label>
              <input v-model="customer.email"
                     type="text"
                     required="required"
                     class="form-control"
                     id="email"
                     placeholder="Enter Customer Email...">
            </div>

            <div class="form-group">
              <label>Date Of Birth</label>
              <div class='input-group date' id='datepicker'>
                <input type='text'
                       class="form-control"
                       v-model="customer.dob"
                        placeholder="Enter Date of Birth"/>
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-calendar"></span>
               </span>
              </div>
            </div>

            <div v-if="customer.accDeletionRequest">
              <div class="form-group">
                <label>Account Delete Reasons</label>
                <textarea rows="5"
                          class="form-control"
                          placeholder="Enter Customer Block Reasons"
                          v-model="customer.deletionMessage"
                          required="required"
                          :disabled="true"
                ></textarea>
              </div>
              <div class="form-group text-center">
                <button type="button"
                        class="btn btn-danger col-lg-12 text-center"
                        @click="revokeCustomerAccDeletionRequest"
                >
                  Revoke Delete Access
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBaykedCustomerDetails,
  revokeCustomerAccDeletionRequest,
  updateBaykedCustomerDetails
} from "../../api/customers";
import moment from "moment";

export default {
  name: "UpdateBaykedCustomer",
  data() {
    return {
      customer: {},
      baykedCustomerModal : "",
      dateFormat: "YYYY-MM-DD"
    }
  },
  mounted() {
    this.baykedCustomerModal = $("#bayked_customer_modal");
    this.jQueryForDatePickerAndContactNumberInputField();
  },
  methods: {
    jQueryForDatePickerAndContactNumberInputField: function (){
      let self= this;
      $('#datepicker').daterangepicker({
        format: self.dateFormat,
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1950,
        maxYear: parseInt(moment().format('YYYY'),0)
      }).on('apply.daterangepicker', function(ev, picker) {
        self.customer.dob = picker.startDate.format(self.dateFormat);
      });
      $("#contactNumber").tooltip({
        trigger: 'hover',
        title: 'Contact Number Should Be Start With 0 Or +',
        placement: 'bottom'
      });
    },
    showBaykedCustomerModal: function (){
      setTimeout(()=>{
        this.baykedCustomerModal.modal("show");
        this.baykedCustomerModal.focus();
      },500);
    },
    formatCustomerDOB: function (){
      this.customer.dob = (this.customer.dob!== null) ? moment(this.customer.dob).format(this.dateFormat) : this.customer.dob;
    },
    load: async function (customer_id) {
      let customerDetailsResp = await getBaykedCustomerDetails(customer_id);
      this.customer = customerDetailsResp.data;
      this.formatCustomerDOB();
      this.showBaykedCustomerModal();
    },
    updateBaykedCustomer: async function () {
      var isValidContactNumber = new RegExp('^(0|\\+)[1-9]*[0-9]{3,}$')
      if(!isValidContactNumber.test($("#contactNumber").val())) {
        swal("TRY AGAIN", "Invalid Phone Number", "error");
      }
      else {
        let updatedCustomerDetailsResp = await updateBaykedCustomerDetails(this.customer);
        if (updatedCustomerDetailsResp.data != null) {
          swal("SUCCESS!", "Customer details updated Successfully!", "success");
          this.baykedCustomerModal.modal("hide");
          this.$parent.dtTable.ajax.reload(null, false);
        } else {
          swal("Error!", "Error while updating customer details!", "error");
        }
      }
    },
    revokeCustomerAccDeletionRequest: async function(){
      this.showLoading();
      let revokeDeletionRequest = await revokeCustomerAccDeletionRequest(this.customer.id);
      if(revokeDeletionRequest.data.status === 200){
        swal("SUCCESS!", "Successfully Revoke the Customer Account Deletion Request!", "success");
        this.customer = revokeDeletionRequest.data.body;
        this.formatCustomerDOB();
      }else{
        swal("ERROR!", "Error while revoking the customer account deletion request\nTRY AGAIN", "error");
      }
      await this.$parent.dtTable.ajax.reload(null, false);
    }
  }
}
</script>

<style scoped>
.margin_bottom{
  margin-bottom: 0;
}
.checkbox{
  margin-top: 2px;
}
input:invalid {
  border: red solid 3px;
}
</style>